import { render } from "./AccountRegistration.vue?vue&type=template&id=1ca963c4"
import script from "./AccountRegistration.vue?vue&type=script&lang=js"
export * from "./AccountRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__